<template>
  <div class="user_info_form user_info_form_contact">
    <h4>변경할 연락처</h4>

    <tel-no-form @update="(val) => (telNo = val)"></tel-no-form>
    <address-form @update="(val) => (address = val)"></address-form>

    <div class="bt">
      <v-button @handleClick="cancelClick" class="btn12 btn_cancel" text="수정 취소" />
      <v-button
        @handleClick="submitClick"
        class="btn11 btn_complete"
        text="수정 완료"
        :disabled="!this.telNo.isState || !this.address.isState"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VButton from '@/components/atoms/VButton';
import TelNoForm from '@/components/modules/common/TelNoForm';
import AddressForm from '@/components/modules/common/AddressForm';

export default {
  components: {
    VButton,
    TelNoForm,
    AddressForm,
  },
  data() {
    return {
      telNo: {},
      address: {},
    };
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
  },
  methods: {
    ...mapActions('userInfo', ['setModifyContact']),
    cancelClick() {
      this.$emit('cancel-click');
    },
    async submitClick() {
      const apiReturn = await this.setModifyContact({
        ...this.telNo.request,
        ...this.address.request,
        businessType: this.userInfo.businessType,
      });
      if (apiReturn === 0) {
        this.$emit('cancel-click');
      }
    },
  },
};
</script>
<style lang="scss"></style>
